import React, { useState } from 'react'
import { Box, Grid, styled, Switch, Tab, Tabs, Typography } from '@mui/material'
import PaperCommon from '../../../Common/PaperCommon';
import MailIcon from '@mui/icons-material/Mail';
import SmsIcon from '@mui/icons-material/Sms';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import { makeStyles } from 'tss-react/mui';
import Notification from './NotificationType/Notificaton';

const CustomSwitch = styled(Switch)(() => ({
    '& .MuiSwitch-switchBase': {
        '&.Mui-checked': {
            '& + .MuiSwitch-track': {
                background: '#0006fb',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: '#3e4094',
    },
    '& .MuiSwitch-track': {
        background: '#d2d3e4',
        opacity: 1,
    },

}));

const useStyles = makeStyles()((theme) => {
    return {
        tabs: {
            '& .MuiTab-root': {
                textTransform: 'none',
                flex: '1 1 auto',
                minWidth: '120px',
                maxWidth: '100%',
                borderRadius: '6px',
                padding: '6px 12px',
                border: '1px solid #E0E0E0',
                color: theme?.palette?.primary?.main,
                fontWeight: 500,
                transition: 'all 0.3s ease',
                minHeight: '35px',
                maxHeight: {
                    xs: '35px',
                    md: '45px',
                },
            },
            '& .MuiButtonBase-root ': {
                '&.Mui-selected': {
                    color: theme?.palette?.bgLightWhite?.main,
                }
            },
            '& .Mui-selected': {
                color: theme?.palette?.bgLightWhite?.main,
                backgroundColor: theme?.palette?.primary?.main,
            },
            '& .MuiTabs-indicator': {
                height: '0px',
            },
            '& .MuiTabs-flexContainer': {
                gap: '5px',
                justifyContent: 'center',
                flexWrap: 'wrap',
            },
            width: "100%"
        }
    }
})

const GeneralNotification = () => {
    // ---------- Hook -----------
    const { classes } = useStyles();
    const tabs = [
        { label: "Mail", icon: <MailIcon />, },
        { label: "SMS", icon: <SmsIcon />, },
        { label: "Notifications", icon: <NotificationAddIcon />, },
    ];

    // --------------- State -------------
    const [tab, setTab] = useState(0);
    const [data, setData] = useState({
        title: "",
        description: "",
        checked: false,
        buttonText: "",
        audience: "",
        image: ""
    })

    // --------------- handleChange ---------------
    const handleChange = ({ target: { name, value } }) => {
        setData({ ...data, [name]: value?.trimStart() })
    }

    const handleChangeTab = (e, newValue) => {
        setTab(newValue)
    };

    return (
        <>
            <Grid container >
                <Grid item xs={12}>
                    <Typography sx={{ fontSize: '20px', fontWeight: 500 }}>General Notification</Typography>
                </Grid>
                <Grid item xs={12}>
                    <PaperCommon padding={{ xs: "10px", md: "30px" }}
                        contant={
                            <Box padding={{ xs: "15px", md: "25px" }} sx={{ backgroundColor: "#F1F1F180", borderRadius: "20px" }}>
                                <Grid item container xs={12} spacing={2} >

                                    <Grid item xs={12}>
                                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', }}>
                                            <Tabs
                                                value={tab}
                                                onChange={handleChangeTab}
                                                textColor="primary"
                                                TabIndicatorProps={{
                                                    style: {
                                                        backgroundColor: '#4D47C3',
                                                        justifyContent: "space-between"
                                                    },
                                                }}
                                                className={classes?.tabs}
                                            >
                                                {tabs?.map((t, index) => (
                                                    <Tab
                                                        icon={t?.icon}
                                                        iconPosition="start"
                                                        label={t?.label}
                                                        defaultValue={tab}
                                                    />
                                                ))}
                                            </Tabs>

                                        </Box>
                                    </Grid>

                                    <Grid item xs={12}>

                                        {tab === 0 && (
                                            <>
                                                <Typography variant="body" >
                                                    In order to send a mail notification, please provide the recipient email address. You can use comma to separate multiple email addresses.
                                                </Typography>
                                            </>
                                        )}
                                        {tab === 1 && (
                                            <>
                                                <Typography variant="body" >
                                                    In order to send a SMS notification, please provide the recipient phone number(s). You can use comma to separate multiple phone numbers.
                                                </Typography>
                                            </>
                                        )}
                                        {tab === 2 && (
                                            <Notification />
                                        )}
                                    </Grid>

                                    {/* <Grid item xs={12} md={6}>
                                        <CommonTextField
                                            valid
                                            value={data?.title}
                                            onChange={handleChange}
                                            backgroundColor={"#ffffff"}
                                            height={"30px"}
                                            width={"100%"}
                                            text="Title"
                                            type="text"
                                            placeholder="Enter your title"
                                            name="title"
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <CommonTextField
                                            valid
                                            value={data?.description}
                                            onChange={handleChange}
                                            height={"30px"}
                                            backgroundColor={"#ffffff"}
                                            width={"100%"}
                                            text="Description"
                                            type="text"
                                            placeholder="Enter your description"
                                            name="description"
                                        />
                                    </Grid>

                                    <Grid item xs={12} mt={1} display={"flex"} alignItems={"center"} flexWrap={"wrap"} gap={1}>
                                        <TextLabel color='#3E4094' fontSize={{ xs: "16px", md: "20px" }} title={"Pause Announcement"} />

                                        <CustomSwitch
                                            checked={data?.checked}
                                            onChange={(e) => setData({ ...data, checked: e.target.checked })}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6} mt={2}>
                                        <CommonTextField
                                            valid
                                            value={data?.buttonText}
                                            onChange={handleChange}
                                            backgroundColor={"#ffffff"}
                                            height={"30px"}
                                            width={"100%"}
                                            text="Button Text"
                                            type="text"
                                            placeholder="Enter your button Text"
                                            name="buttonText"
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6} mt={2}>
                                        <CommonTextField
                                            valid
                                            value={data?.audience}
                                            onChange={handleChange}
                                            height={"30px"}
                                            backgroundColor={"#ffffff"}
                                            width={"100%"}
                                            text="Audience"
                                            type="text"
                                            placeholder="Enter your audience"
                                            name="audience"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4} mt={2} display={"flex"} gap={1}>

                                        <ButtonOutlined
                                            width={"100%"}
                                            text={"Cancel"}
                                            color={"#3E4094"}
                                            lineHeight={"24.5px"}
                                            backgroundColor={"#fff"}
                                            border={"1px solid #3E4094"}
                                            padding={{ xs: "5px 10px", md: "10px 20px" }}
                                            fontSize={{ xs: "12px", md: "14px" }}
                                            height={{ xs: "40px", sm: "44px" }}
                                        />

                                        <ButtonContained
                                            width={"100%"}
                                            text={"Comfirm"}
                                            lineHeight={"24.5px"}
                                            padding={{ xs: "5px 10px", md: "10px 20px" }}
                                            fontSize={{ xs: "12px", md: "14px" }} SSSSS
                                            height={{ xs: "40px", sm: "44px" }}
                                        />

                                    </Grid> */}

                                </Grid>
                            </Box>
                        } />
                </Grid >
            </Grid >
        </>
    )
}

export default GeneralNotification
